import {createAsyncThunk} from '@reduxjs/toolkit'
import {toast as message} from 'react-toastify'
import {getApi, patchApi, postApi} from '../../../axios'
import {API_ERROR} from '../../../global'
import {PREORDERTAX, TRANSACTIONLIST} from '../../../axios/services'

export const getTransactionlist = createAsyncThunk(
  'tsc/getTransactionlist',
  async (payload = {}, thunkAPI) => {
    try {
      const authData = JSON.parse(localStorage.getItem('auth') || 'null')
      const roles = authData?.role?.split(',').map((role) => role.trim()) || []
      const isSuperUser = roles.includes('coms_admin')

      const params = {
        got_created: payload?.created || '',
        page: payload?.page || 1,
        is_available: payload?.is_available || '', 
        items_per_page: 10,
      }

      if (isSuperUser) {
        params.admin_roles = 'coms_admin'
      }

      const queryString = new URLSearchParams(params).toString()

      const response = await getApi(`${TRANSACTIONLIST}?${queryString}`)

      if (response?.data?.success) {
        return response?.data
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR)
      return thunkAPI.rejectWithValue(error?.response?.data?.message)
    }
  }
)




export const createBillingtax = createAsyncThunk(
  'tsc/createBillingtax',
  async ({body, next = () => {}}, thunkAPI) => {
    try {
      const response = await postApi(PREORDERTAX, body)
      if (response?.data?.success) {
        message.success(response?.data?.message)
        next(response?.data)
        return response?.data
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR)
      return thunkAPI.rejectWithValue(error.response.data.message)
    }
  }
)



export const patchBillingtax = createAsyncThunk(
  'tsc/patchBillingtax',
  async ({body, next = () => {}}, thunkAPI) => {
    try {
      const response = await patchApi(PREORDERTAX, body)
      if (response?.data?.success) {
        message.success(response?.data?.message)
        next(response?.data)
        return response?.data
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR)
      return thunkAPI.rejectWithValue(error.response.data.message)
    }
  }
)



export const getBillingtax = createAsyncThunk(
  'tsc/getBillingtax',
  async ({ tax_type, next = () => {} }, thunkAPI) => {
    try {
      // const response = await getApi(`${PREORDERTAX}`) 
      const response = await getApi(
        `${PREORDERTAX}?tax_type=${tax_type}`
      )
      if (response?.data?.success) {
        next(response?.data)
        return response?.data
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR)
      return thunkAPI.rejectWithValue(error.response.data.message)
    }
  }
)
